<template>
  <router-link
    :to="'/goal/' + goalId + '/dashboard'"
    :class="{
      'goal-inline-menubar': true,
      'is-selected':         selected
    }">
    <div class="menubar-goal__picture">
      <div
        class="goal-inline-menubar-image"
        :style="background_image_css">
      </div>
    </div>
    <div class="menubar-goal__name" >
      {{ goal_meta.name }}
    </div>
    <!--
    <div class="p-0 ml-auto">
        <font-awesome-icon
          class="goal-inline-menubar-icon"
          size="lg"
          icon="list-alt"
          @click.prevent.stop="onGoToGoalKanban"
          v-tooltip="{ content: 'Go to Tasks'}"/>
      <font-awesome-icon
        class="goal-inline-menubar-icon"
        size="lg"
        :icon="['far', sessionIsActive ? 'pause-circle' : 'play-circle' ]"
        @click.prevent.stop="onClickSessionPlayPause" />
    </div>
    -->
    <!--
    <div class="menubar-goal">
      <div class="menubar-goal__image">
        <img :src="goal_meta.picture" />
      </div>
      <div class="menubar-goal__name" >
        {{ goal_meta.name }}
      </div>
    </div>
    -->
  </router-link>
</template>

<script>
export default {
  props: {
    goalId: {
      required: true
    },
    selected: {
      default: false
    }
  },
  data: () => ({
    sessionIsActive: false // TODO
  }),
  computed: {
    // ...mapGetters("goal", [
    //   "goal_list_state",
    //   "goal_by_id",
    //   "goal_is_ready"
    // ]),

    // goalIsReady() {
    //   return this.goal_is_ready( this.goalId );
    // },

    goal_meta() {
      // return this.goal_by_id( this.goalId );
      return this.$models.goalMeta.getNode( this.goalId );
    },

    // goalMetaData() {
    //   if ( thos.goal_meta.$ready ) {
    //     let goal = this.goal_list_state[ this.goalId ]
    //     return goal.meta ? { ...goal.meta, id: this.goalId } : null;
    //   }
    //   return null;
    // },

    background_image_css() {
      return this.goal_meta.picture
              ? {
                backgroundImage: 'url(' + this.goal_meta.picture + ')',
                backgroundSize: 'cover'
              } : {}
    }
  },
  methods: {
    onSelect() {
      this.$emit('select', this.goalId);
    },

    onClickSessionPlayPause() {
      console.log("onClickSessionPlayPause", this.goalId, this.sessionIsActive);
      this.sessionIsActive = !this.sessionIsActive; // HACK
    },

    onGoToGoalKanban() {
      this.$router.push('/goal/' + this.goalId + '/kanban')
    }
  },
}
</script>

<style>
/* TODO: Move to menubar.scss */

.goal-inline-menubar-image {
  width: 24px;
  height: 24px;

  margin: 0 auto;
  border-radius: 3px;

  background-color: gray;
  background-position: 50% 25%;
  background-repeat: no-repeat;

  /* Default image */
  background-size: contain;
  background-image: url('../../assets/goal_placeholder.png');
}
.goal-inline-menubar-image img {
  flex-shrink: 0;
  min-width: 100%;
  min-height: 100%
}

/*.
.goal-inline-menubar-image:hover {
  opacity: 0.5;
}
goal-inline-menubar-text {
  font-weight: bold;
  font-size: 10pt;
  line-height: 24px;
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-right: 5px;
}
.menubar-goal {
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: nowrap;
  justify-content: flex-start;
  width: 105px;
}
.goal-inline-menubar.is-selected {
  border-left: 4px solid #4285f4;
  margin-left: -5px;
  padding-left: 5px;
}
.goal-inline-menubar-icon {
  margin-right: 0 !important;
  line-height: 42px;
  height: 100% !important;
  width: 23px !important;
}
svg.goal-inline-menubar-icon {
}
*/

</style>
